module.exports = __webpack_public_path__ + "static/img/gaozhongwuli5.4fbe3242.jpg";